import { Asset } from './assets';
import { LiquidityProvider } from './pwcOrder';

export enum CryptoPayoutPaymentMethod {
  Onchain = 'onchain',
  BinancePay = 'binance_pay',
}

export enum CryptoPayoutStatus {
  Initiated = 'INITIATED',
  Pending = 'PENDING',
  Submitted = 'SUBMITTED',
  Confirmed = 'CONFIRMED',
  Completed = 'COMPLETED',
  Canceled = 'CANCELED',
  Failed = 'FAILED',
}

export enum BridgeKycStatus {
  NotStarted = 'not_started',
  Pending = 'pending',
  Incomplete = 'incomplete',
  AwaitingUbo = 'awaiting_ubo',
  ManualReview = 'manual_review',
  UnderReview = 'under_review',
  Approved = 'approved',
  Rejected = 'rejected',
  Paused = 'paused',
  Active = 'active',
}

export interface CryptoPayoutCustomer {
  uuid: string;
  email: string;
  firstName: string;
  lastName: string;
  createdAt: string;
  lastPurchasedAt: string | null;
  dob?: string;
  issuingCountry?: string;
  countryOfResidence?: string;
  idType?: string;
  idNumber?: string;
  isTosAccepted?: boolean;
  kycStatus: BridgeKycStatus;
}

export interface CryptoPayoutStatusTransitionHistory {
  uuid: string;
  cryptoPayoutUuid: string;
  from: CryptoPayoutStatus;
  to: CryptoPayoutStatus;
  createdAt: string;
}

export interface CryptoPayout {
  uuid: string;
  customerUuid: string;
  merchantUuid: string;
  status: CryptoPayoutStatus;
  method?: CryptoPayoutPaymentMethod | null;
  createdAt: string;
  processedAt?: string | null;
  fiatAmount: number;
  fiatCurrencyCode: string;
  cryptoCurrencyCode: string | null;
  cryptoCurrencyIcon: string | null;
  cryptoAmount: string | null;
  walletAddress: string | null;
  walletMemo: string | null;
  onChainTransactionHash: string | null;
  onChainExplorerURL: string | null;
  network: string | null;
  cryptoPrice?: string | null;
  networkFee?: string | null;
  liquidityProvider: LiquidityProvider | null;
  liquidityProviderId: string | null;
  externalPayoutId: string | null;
  webhookUrl: string | null;
  processingFeePercent: number;
  processingFeeFiatAmount: number | null;
  statusHistory: CryptoPayoutStatusTransitionHistory[];
  customer: CryptoPayoutCustomer;
  token: string;
  link: string;
  cryptoAsset: Asset;
  isCancelable: boolean;
}
